import React from "react";

import Navbar from "./components/navbar";
import Main from "./components/main";

const App = () => {
   return (
      <div>
         <Navbar />
         <Main />
      </div>
   );
};

export default App;
